var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendCnh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 314,
    viewBox: "0 0 338 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9719_11065",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 48,
    width: 278,
    height: 231
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.946 235.937C249.044 274.924 201.936 287.888 177.026 272.309C155.9 259.095 157.689 237.57 137.969 238.28C122.418 238.839 114.613 249.068 98.4477 252.796C68.5313 259.696 11.8509 200.126 26.2988 155.488C38.9892 116.281 74.0856 95.1241 106.54 87.378C157.862 80.093 167.464 51.5248 212.811 48.923C247.914 46.9086 274.134 121.175 287.463 131.952C306.389 147.255 305.07 196.642 276.946 235.937Z",
    fill: "#667DBB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9719_11065)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9719_11065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.296 143.586C176.455 147.921 170.529 149.224 166.031 146.502L137.94 128.593C133.459 125.845 132.113 120.113 134.927 115.761C137.767 111.426 143.693 110.124 148.191 112.846L176.282 130.754C180.763 133.503 182.109 139.235 179.296 143.586Z",
    fill: "url(#paint0_linear_9719_11065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.744 142.606C175.105 146.637 169.595 147.849 165.414 145.318L139.3 128.657C135.133 126.103 133.881 120.773 136.497 116.728C139.137 112.697 144.646 111.485 148.828 114.016L174.944 130.664C179.119 133.219 180.371 138.559 177.744 142.606Z",
    fill: "#F8DADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.801 228.645C267.796 217.682 258.606 208.799 247.274 208.804C237.424 208.809 228.967 215.584 227.126 224.945L164.068 223.293L164.783 233.771C164.783 233.771 155.793 253.841 203.048 259.196V279.488H257.687V245.769C263.961 242.201 267.809 235.685 267.801 228.645Z",
    fill: "url(#paint1_linear_9719_11065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.708 237.292C158.384 242.939 162.334 254.711 199.15 258.557V291.46L255.901 277.993V226.511L158.68 224.16L158.711 224.614C158.983 228.836 158.982 233.07 158.708 237.292Z",
    fill: "#F8DADB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.732 71.9795L158.727 72.1777C156.821 72.1824 155.28 73.6795 155.283 75.5227L155.676 227.522C155.681 229.366 157.23 230.858 159.136 230.853L243.142 230.655C245.049 230.65 246.59 229.151 246.586 227.307L246.196 75.3107C246.191 73.4664 244.642 71.9748 242.735 71.9795C242.734 71.9795 242.733 71.9795 242.732 71.9795Z",
    fill: "url(#paint2_linear_9719_11065)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.39 74.2448L241.08 74.054C243.224 74.049 244.966 75.7262 244.971 77.8001L245.342 224.747C245.348 226.821 243.614 228.507 241.47 228.512L160.78 228.702C158.636 228.707 156.894 227.03 156.889 224.956L156.518 78.009C156.512 75.9351 158.246 74.2497 160.39 74.2448Z",
    fill: "#305568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.965 77.9702C222.444 81.3548 219.45 83.8667 215.913 83.8865L185.36 83.9581C181.822 83.9556 178.814 81.4578 178.277 78.0748L162.093 78.1133C160.237 78.118 158.737 79.5755 158.74 81.3702L159.09 221.583C159.095 223.378 160.602 224.83 162.457 224.827L239.758 224.645C241.613 224.64 243.113 223.183 243.11 221.388L242.757 81.1747C242.752 79.38 241.246 77.9286 239.391 77.9316L222.965 77.9702Z",
    fill: "#305568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.658 80.0182L209.228 79.7484C209.542 79.7437 209.801 79.9865 209.806 80.2907L209.807 80.3816C209.812 80.6855 209.561 80.9358 209.247 80.9404L190.677 81.2102C190.363 81.2149 190.104 80.9721 190.099 80.6679L190.098 80.577C190.093 80.2728 190.344 80.0228 190.658 80.0182Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.004 80.8724C214.413 80.8664 214.739 80.5412 214.733 80.1459C214.727 79.7506 214.391 79.435 213.982 79.4409C213.573 79.4469 213.247 79.7721 213.253 80.1674C213.259 80.5627 213.596 80.8783 214.004 80.8724Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M207.936 212.395C208.213 208.625 205.278 205.351 201.381 205.083C197.483 204.815 194.099 207.654 193.822 211.424C193.545 215.195 196.48 218.469 200.377 218.737C204.275 219.005 207.659 216.165 207.936 212.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.876 216.733C203.63 216.733 205.862 214.573 205.862 211.909C205.862 209.245 203.63 207.086 200.876 207.086C198.123 207.086 195.891 209.245 195.891 211.909C195.891 214.573 198.123 216.733 200.876 216.733Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M177.128 207.755H168.539V216.064H177.128V207.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M232.135 208.95V208.036C232.135 207.884 232.007 207.76 231.85 207.76H228.529C228.372 207.76 228.245 207.884 228.245 208.036V208.95H226.958V208.399H226.196V208.95H225.242V214.475H235.143V208.95H232.135V208.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.068 94.1003H158.684V196.509H243.068V94.1003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M233.973 89.946C235.229 89.946 236.247 88.9612 236.247 87.7463C236.247 86.5315 235.229 85.5466 233.973 85.5466C232.717 85.5466 231.699 86.5315 231.699 87.7463C231.699 88.9612 232.717 89.946 233.973 89.946Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M235.489 92.1457C236.744 92.1457 237.762 91.1609 237.762 89.946C237.762 88.7312 236.744 87.7463 235.489 87.7463C234.233 87.7463 233.215 88.7312 233.215 89.946C233.215 91.1609 234.233 92.1457 235.489 92.1457Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M232.205 92.1457C233.461 92.1457 234.479 91.1609 234.479 89.946C234.479 88.7312 233.461 87.7463 232.205 87.7463C230.95 87.7463 229.932 88.7312 229.932 89.946C229.932 91.1609 230.95 92.1457 232.205 92.1457Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M164.495 85.5466L168.033 87.7463L162.979 89.946L165.506 92.1457",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.97 248.307C256.821 248.307 265.617 239.797 265.617 229.3C265.617 218.803 256.821 210.293 245.97 210.293C235.119 210.293 226.322 218.803 226.322 229.3C226.322 239.797 235.119 248.307 245.97 248.307Z",
    fill: "#F8DADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.671 232.651C252.979 233.925 249.055 230.33 247.737 224.815L234.647 177.738C233.341 172.203 236.901 166.687 242.615 165.391C248.337 164.128 254.039 167.572 255.378 173.099L266.073 221.382C267.379 226.913 264.385 231.376 258.671 232.651Z",
    fill: "url(#paint3_linear_9719_11065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.218 168.864C247.029 167.788 251.831 170.69 252.943 175.344L264.991 225.789C266.102 230.444 263.103 235.089 258.292 236.165C253.48 237.24 248.679 234.339 247.567 229.684L235.519 179.239C234.407 174.584 237.406 169.939 242.218 168.864Z",
    fill: "#F8DADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.787 223.717C167.956 228.038 162.049 229.337 157.565 226.624L145.898 218.39C141.431 215.651 140.088 209.937 142.892 205.599C145.723 201.278 151.63 199.979 156.114 202.692L167.782 210.926C172.249 213.665 173.592 219.379 170.787 223.717Z",
    fill: "url(#paint4_linear_9719_11065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.848 223.106C167.208 227.137 161.698 228.348 157.517 225.818L146.634 218.131C142.467 215.577 141.215 210.247 143.831 206.202C146.471 202.171 151.98 200.959 156.162 203.49L167.044 211.168C171.216 213.723 172.469 219.059 169.848 223.106Z",
    fill: "#F8DADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.402 146.944H172.287C171.615 146.943 171.071 146.269 171.07 145.436V108.072C171.071 107.24 171.615 106.565 172.287 106.564H230.402C231.073 106.565 231.617 107.24 231.618 108.072V145.436C231.617 146.269 231.073 146.943 230.402 146.944Z",
    stroke: "#315669",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.21 131.362H181.363C180.345 131.361 179.501 130.515 179.5 129.446V114.416C179.501 113.348 180.345 112.501 181.363 112.5H199.211C200.229 112.501 201.072 113.348 201.073 114.416V129.446C201.072 130.514 200.229 131.361 199.21 131.362Z",
    stroke: "#315669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.331 186.38H172.216C171.545 186.379 171.001 185.721 171 184.909V148.471C171.001 147.659 171.545 147.001 172.216 147H230.331C231.003 147.001 231.547 147.659 231.548 148.471V184.909C231.547 185.721 231.003 186.379 230.331 186.38Z",
    stroke: "#315669",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.388 173.917C177.57 178.22 171.688 179.513 167.224 176.81L143.347 161.77C138.896 159.043 137.559 153.349 140.356 149.029C143.175 144.726 149.057 143.433 153.521 146.136L177.398 161.176C181.849 163.903 183.186 169.597 180.388 173.917Z",
    fill: "url(#paint5_linear_9719_11065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.119 173.13C176.479 177.161 170.969 178.372 166.788 175.841L144.425 161.757C140.258 159.203 139.006 153.873 141.622 149.828C144.258 145.783 149.779 144.564 153.967 147.102L176.33 161.187C180.5 163.745 181.747 169.085 179.119 173.13Z",
    fill: "#F8DADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.513 198.755C172.708 203.031 166.864 204.318 162.422 201.637L143.583 189.846C139.164 187.133 137.833 181.479 140.604 177.182C143.408 172.907 149.253 171.62 153.694 174.3L172.534 186.091C176.953 188.804 178.284 194.458 175.513 198.755Z",
    fill: "url(#paint6_linear_9719_11065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.483 198.116C171.843 202.147 166.334 203.359 162.152 200.828L144.425 189.733C140.258 187.18 139.006 181.85 141.622 177.804C144.263 173.765 149.783 172.552 153.967 175.093L171.68 186.196C175.841 188.749 177.093 194.073 174.483 198.116Z",
    fill: "#F8DADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 178.5H221",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5 121C193.776 121 194 120.776 194 120.5C194 120.224 193.776 120 193.5 120C193.224 120 193 120.224 193 120.5C193 120.776 193.224 121 193.5 121Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.885 122.295C185.885 122.295 184.531 128.66 183.793 128.323C183.793 128.323 190.917 133.948 197.206 128.323C197.206 128.323 196.099 123.758 194.498 122.295H185.885Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 126.559C193.463 126.559 195.865 124.332 195.865 121.585C195.865 118.838 193.463 116.611 190.5 116.611C187.537 116.611 185.135 118.838 185.135 121.585C185.135 124.332 187.537 126.559 190.5 126.559Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.159 127.981H191.841V131.795C191.841 132.043 191.676 132.244 191.473 132.244H189.526C189.323 132.244 189.158 132.043 189.158 131.795V127.981H189.159Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 127.981C193.463 127.981 195.865 125.753 195.865 123.006C195.865 120.259 193.463 118.032 190.5 118.032C187.537 118.032 185.135 120.259 185.135 123.006C185.135 125.753 187.537 127.981 190.5 127.981Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.135 120.874H195.865C195.865 120.874 194.949 117.848 190.893 118.041C186.837 118.234 185.135 120.874 185.135 120.874Z",
    fill: "black"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.875 139.819H68.125C67.504 139.818 67.0008 139.203 67 138.445V104.391C67.0008 103.633 67.504 103.018 68.125 103.017H121.875C122.496 103.018 122.999 103.633 123 104.391V138.445C122.999 139.203 122.496 139.818 121.875 139.819Z",
    fill: "white",
    stroke: "#305568",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0896 124.933C75.6248 124.933 75.248 125.488 75.248 126.173C75.248 126.858 75.6248 127.414 76.0896 127.414H118.686C119.15 127.414 119.527 126.858 119.527 126.173C119.527 125.488 119.15 124.933 118.686 124.933H76.0896Z",
    fill: "#305568"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6082 113.354C98.173 113.354 97.8203 113.817 97.8203 114.388C97.8203 114.959 98.173 115.422 98.6082 115.422H115.699C116.134 115.422 116.487 114.959 116.487 114.388C116.487 113.817 116.134 113.354 115.699 113.354H98.6082V113.354Z",
    fill: "#59A284"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4267 119.144C98.0918 119.144 97.8203 119.607 97.8203 120.178C97.8203 120.749 98.0918 121.212 98.4267 121.212H118.485C118.82 121.212 119.092 120.749 119.092 120.178C119.092 119.607 118.82 119.144 118.485 119.144H98.4267Z",
    fill: "#59A284"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0896 130.722C75.6248 130.722 75.248 131.278 75.248 131.963C75.248 132.648 75.6248 133.203 76.0896 133.203H118.686C119.15 133.203 119.527 132.648 119.527 131.963C119.527 131.278 119.15 130.722 118.686 130.722H76.0896Z",
    fill: "#305568"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5163 121.397H78.209C77.3098 121.396 76.5812 120.703 76.5801 119.848V110.209C76.5812 109.354 77.3098 108.661 78.209 108.66H90.5163C91.4155 108.661 92.1442 109.354 92.1453 110.209V119.848C92.1444 120.703 91.4157 121.396 90.5163 121.397Z",
    fill: "#59A284"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2178 119.837C86.997 119.837 89.2501 117.695 89.2501 115.051C89.2501 112.408 86.997 110.266 84.2178 110.266C81.4386 110.266 79.1855 112.408 79.1855 115.051C79.1855 117.695 81.4386 119.837 84.2178 119.837Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3489 120.343C86.4175 120.343 88.0944 118.748 88.0944 116.781C88.0944 114.814 86.4175 113.219 84.3489 113.219C82.2804 113.219 80.6035 114.814 80.6035 116.781C80.6035 118.748 82.2804 120.343 84.3489 120.343Z",
    fill: "#305568"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6133 114.51C82.076 115.359 83.7251 115.875 85.432 116.02L84.9241 115.441C85.2939 115.571 85.6832 115.644 86.0772 115.659C86.4772 115.67 86.8591 115.5 87.1065 115.2C87.3087 114.889 87.338 114.504 87.1851 114.168C87.0303 113.839 86.7894 113.552 86.4852 113.336C85.3902 112.512 83.9343 112.265 82.6071 112.677C82.1589 112.805 81.7575 113.049 81.4487 113.384C81.1405 113.726 81.0339 114.192 81.1648 114.625",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.875 174.802H68.125C67.504 174.801 67.0008 174.22 67 173.502V141.3C67.0008 140.582 67.504 140.001 68.125 140H121.875C122.496 140.001 122.999 140.582 123 141.3V173.502C122.999 174.22 122.496 174.801 121.875 174.802Z",
    fill: "white",
    stroke: "#305568",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0896 166.199C75.6248 166.199 75.248 166.724 75.248 167.372C75.248 168.02 75.6248 168.545 76.0896 168.545H118.686C119.15 168.545 119.527 168.02 119.527 167.372C119.527 166.724 119.15 166.199 118.686 166.199H76.0896Z",
    fill: "#667DBB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0896 166.199C75.6248 166.199 75.248 166.724 75.248 167.372C75.248 168.02 75.6248 168.545 76.0896 168.545H118.686C119.15 168.545 119.527 168.02 119.527 167.372C119.527 166.724 119.15 166.199 118.686 166.199H76.0896Z",
    fill: "#667DBB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.404 177.654C180.939 177.654 180.562 178.179 180.562 178.827C180.562 179.475 180.939 180 181.404 180H224C224.465 180 224.842 179.475 224.842 178.827C224.842 178.179 224.465 177.654 224 177.654H181.404Z",
    fill: "#305568"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80 165.35C80.6293 166.19 82.1042 165.952 82.9666 165.748C85.0355 165.259 86.9367 164.323 88.8797 163.487C89.086 163.398 89.3606 163.157 89.5017 163.429C89.6676 163.749 89.7279 164.103 89.8467 164.439C89.9323 164.681 90.0341 164.814 90.2874 164.681C91.3575 164.117 92.3744 163.514 93.5109 163.076C93.6651 163.017 95.0058 162.372 95.0849 162.893C95.1373 163.237 95.0093 163.59 95.0345 163.935C95.0454 164.084 95.1768 164.032 95.2713 163.986C95.6281 163.811 95.9516 163.609 96.3416 163.507C97.1119 163.305 97.0127 164.255 97.4572 164.638C97.6708 164.822 97.9976 164.815 98.258 164.766C99.0487 164.619 99.8249 164.256 100.53 163.885C101.356 163.449 102.15 162.979 102.904 162.429C103.062 162.314 103.487 161.915 103.733 162.016C104.018 162.133 104.103 162.923 104.161 163.154C104.241 163.473 104.304 164.14 104.594 164.368C104.682 164.437 105.217 163.972 105.267 163.94C105.742 163.632 106.224 163.281 106.72 163.008C107.537 162.558 107.422 164.473 107.918 164.776C108.112 164.894 108.591 164.486 108.699 164.404C109.328 163.923 109.814 163.297 110.409 162.782C110.743 162.493 111.309 162.05 111.802 162.152C112.187 162.232 112.517 162.893 112.718 163.167C113.142 163.743 113.586 164.301 113.942 164.922C114.078 165.159 114.204 165.451 114.418 165.633C114.445 165.655 114.482 165.407 114.496 165.35",
    stroke: "#305568",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.777 176.603C187.407 177.442 188.882 177.205 189.744 177.001C191.813 176.512 193.714 175.576 195.657 174.74C195.863 174.651 196.138 174.41 196.279 174.682C196.445 175.001 196.505 175.356 196.624 175.692C196.71 175.934 196.811 176.067 197.065 175.934C198.135 175.37 199.152 174.766 200.288 174.329C200.442 174.27 201.783 173.625 201.862 174.145C201.915 174.49 201.787 174.843 201.812 175.188C201.823 175.337 201.954 175.285 202.049 175.238C202.405 175.064 202.729 174.862 203.119 174.76C203.889 174.558 203.79 175.508 204.235 175.891C204.448 176.075 204.775 176.067 205.035 176.019C205.826 175.872 206.602 175.509 207.307 175.138C208.133 174.702 208.927 174.232 209.682 173.682C209.839 173.567 210.264 173.168 210.51 173.269C210.796 173.386 210.88 174.176 210.938 174.407C211.018 174.726 211.081 175.393 211.372 175.621C211.459 175.69 211.994 175.225 212.044 175.193C212.519 174.884 213.001 174.534 213.497 174.261C214.314 173.811 214.199 175.726 214.696 176.029C214.889 176.147 215.369 175.739 215.476 175.657C216.105 175.176 216.591 174.55 217.186 174.035C217.52 173.746 218.087 173.303 218.579 173.405C218.965 173.485 219.295 174.146 219.496 174.42C219.919 174.996 220.364 175.554 220.72 176.175C220.855 176.412 220.981 176.704 221.196 176.885C221.222 176.908 221.26 176.66 221.274 176.603",
    stroke: "#305568",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9719_11065",
    x1: 157.111,
    y1: 147.924,
    x2: 157.111,
    y2: 111.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9719_11065",
    x1: 215.935,
    y1: 279.488,
    x2: 215.935,
    y2: 208.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9719_11065",
    x1: 165.204,
    y1: 233.614,
    x2: 232.748,
    y2: 67.6322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9719_11065",
    x1: 250.377,
    y1: 232.908,
    x2: 250.377,
    y2: 165.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9719_11065",
    x1: 156.84,
    y1: 228.041,
    x2: 156.84,
    y2: 201.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9719_11065",
    x1: 160.372,
    y1: 178.222,
    x2: 160.372,
    y2: 144.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9719_11065",
    x1: 158.058,
    y1: 203.036,
    x2: 158.058,
    y2: 172.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9719_11065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.344,
    height: 207.509,
    fill: "white",
    transform: "translate(133.457 71.9795)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCnh);
export default __webpack_public_path__ + "static/media/send-cnh.e6b32a1f7e048247bb022ac8c6a618ca.svg";
export { ForwardRef as ReactComponent };